export enum Role {
    PORTAL_MASTER = "ptb2b_portalmaster",
    DISTRIBUTOR = "ptb2b_distributor",
    SALES_REP = "salesrepgroup",
    DEALER = "ptb2b_dealer",
    HEADQUARTERS = "ptb2b_headquarter",
    DI_SALES_REP = "ptb2b_di_salesrep",
    DI_DEALER = "ptb2b_di_dealer",
    ORDER_RESTRICTED = "orderRestrictedUserGroup"
  }
